import { AxiosError, AxiosResponse } from 'axios';
import { sponsorAxiosInstance } from '../base-service';

const onResponse = (response: AxiosResponse) => {
  return response;
};

const onErrorResponse = (errResponse: AxiosError) => {
  return errResponse;
};

export const registerResponseInterceptors = (): void => {
  sponsorAxiosInstance.interceptors.response.use(onResponse, onErrorResponse);
};
